import axios from "../../../../../axios";
import Cookies from "js-cookie";

//Get All Rejected Candidates
export const GetAllRejectedCandidates = async () => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Candidate/GetRejectedCandidates", {
    token,
  });
};